import {FormField, RequiredFormField} from "../../../../validation/FormField";
import FormValidation from "../../../../validation/FormValidation";
import {none, option} from "ts-option";
import {ValidationResult} from "../../../../validation/ValidationResult";
import BaseFormController from "../../../../validation/BaseFormController";
import FormValidators from "../../../../validation/FormValidators";
import Utility from "../../../../model/utility/Utility";

const uuidv4 = require("uuid/v4");

export default class UtilityForm extends BaseFormController<UtilityForm> {
	constructor(formId: string,
		public readonly name: RequiredFormField<string>) {
		super(name, formId);
	}

	static createUtilityForm({name = none}) {
		return new UtilityForm(
			uuidv4(),
			RequiredFormField.create<string>(name, "Utility name is required", [
				FormValidators.nonEmptyString("Utility name is required")
			])
		)
	}

	public static createEmpty(): UtilityForm {
		return this.createUtilityForm({});
	}

	static fromUtility(utility: Utility) {
		return UtilityForm.createUtilityForm({
			name: option(utility.name)
		});
	}

	validate(): UtilityForm {
		return FormValidation.validateForm<UtilityForm>(this, (form, config) => form.copy(config));
	}

	onValid(onValid: (utility: Utility) => void,
		onInvalid: () => void = () => {}): ValidationResult<Utility> {
		return FormValidation.validateFields(
			[this.name],
			() => {
				return new Utility("", this.name.getValue());
			}).onSuccess(utility => onValid(utility)).onFailure(() => onInvalid());
	}

	copy({
		name = this.name
	}): UtilityForm {
		return new UtilityForm(this.formId, name)
	}

	fields(): Array<FormField<any>> {
		return [this.name];
	}
}